/* util/point-in-polygon.js — ray-casting punkt-i-polygon-test.
 *
 * Standardalgoritm (W. Randolph Franklin): skjut en horisontell stråle åt
 * öster och räkna hur många kanter den korsar. Udda → inom, jämnt → utanför.
 * Hanterar polygoner med hål via even-odd-rule per ring (XOR av ring-tester).
 *
 * Polygon-coords följer GeoJSON-konventionen:
 *   [outerRing, ...holes]
 *   där varje ring är [[lng,lat], [lng,lat], ..., [lng,lat]] med första
 *   = sista (sluten ring).
 *
 * Public API:
 *   pointInPolygon([lng, lat], polygonCoords)  → boolean
 */

function pointInRing(lng, lat, ring) {
    let inside = false;
    for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
        const xi = ring[i][0], yi = ring[i][1];
        const xj = ring[j][0], yj = ring[j][1];
        const intersect = ((yi > lat) !== (yj > lat))
            && (lng < (xj - xi) * (lat - yi) / ((yj - yi) || 1e-12) + xi);
        if (intersect) inside = !inside;
    }
    return inside;
}

export function pointInPolygon(point, polygonCoords) {
    if (!Array.isArray(point) || point.length < 2) return false;
    if (!Array.isArray(polygonCoords) || !polygonCoords.length) return false;
    const [lng, lat] = point;
    // Outer ring måste innehålla punkten.
    if (!pointInRing(lng, lat, polygonCoords[0])) return false;
    // Hål: om punkten är i ett hål → utanför polygonen.
    for (let h = 1; h < polygonCoords.length; h++) {
        if (pointInRing(lng, lat, polygonCoords[h])) return false;
    }
    return true;
}
